<template>
  <div>
    <div class="page checkout">
      <div>
        <div class="card card-body shadow-4 p-6" style="max-width: 500px; margin: auto; margin-top: 10px; background-color: #eee;">
          <template v-if="checkoutPlan !== 'NEWCARD'">
            <div class="text-primary text-center"><label>Récapitulatif de votre commande « {{ checkoutPlanName }} »</label></div>
            <table>
              <tr>
                <td class="py-1">
                  <b>Abonnement {{ checkoutPlanPeriod }} {{ checkoutQuantity }} utilisateur{{ checkoutQuantity > 1 ? 's' : '' }}</b>
                  <div v-if="couponDiscount" class="text-success">Offre spéciale {{ checkoutCoupon }} -{{ couponDiscount * 100 }}%</div>
                </td>
                <td>
                  <template v-if="couponDiscount">
                    <div style="text-decoration: line-through">{{ number_format(checkoutQuantity * checkoutPrice) }} €</div>
                    <div>{{ number_format(checkoutQuantity * checkoutPrice * (1 - couponDiscount)) }} €</div>
                  </template>
                  <template v-else>{{ number_format(checkoutQuantity * checkoutPrice) }} €</template>
                </td>
              </tr>
              <tr>
                <td class="py-1">TVA 20%</td>
                <td>{{ number_format(checkoutQuantity * checkoutPrice * (1 - couponDiscount) * .2) }} €</td>
              </tr>
              <tr>
                <td class="py-1">Total TTC {{ checkoutPlanPeriod }}</td>
                <td>{{ number_format(checkoutQuantity * checkoutPrice * (1 - couponDiscount) * 1.2) }} €</td>
              </tr>
              <tr>
                <td colspan="2" class="py-2" style="line-height: 1.5">
                  <span>Renouvellement </span>
                  <span v-if="checkoutPlanPeriod == 'mensuel'">mensuel le {{ checkoutTrialEnd.day }}</span>
                  <span v-if="checkoutPlanPeriod == 'annuel'">annuel le {{ checkoutTrialEnd.dayAndMonth }}</span>
                </td>
              </tr>
            </table>
          </template>
          <form v-show="! formCheckout.showSuccess" action="#" autocomplete="on">
            <div class="text-center mt-2">
              <div class="card-button"><img src="assets/img/cards/card-visa-logo.svg" alt="visa" style="height:30px"></div>
              <div class="card-button"><img src="assets/img/cards/card-mastercard-logo.svg" alt="mastercard" style="height:30px"></div>
              <div class="card-button"><img src="assets/img/cards/card-maestro-logo.svg" alt="maestro" style="height:30px"></div>
              <div class="card-button"><img src="assets/img/cards/card-amex-logo.svg" alt="american express" style="height:30px"></div>
            </div>
            <div style="margin-top: 10px;">
              <label for="number">Numéro de carte</label>
              <div id="number" class="form-control" style="display: flex; flex-direction: column; justify-content: center;"></div>
            </div>
            <div style="margin-top: 10px;">
              <label for="cardholder-name">Nom du titulaire</label>
              <input id="cardholder-name" v-model="formCheckout.cardholderName" type="text" size="20" class="form-control" placeholder="Jean Durand">
            </div>
            <div style="margin-top: 10px;">
              <label for="exp">Expire fin</label>
              <div id="exp" class="form-control" style="width: 180px; display: flex; flex-direction: column; justify-content: center;"></div>
            </div>
            <div style="margin-top: 10px;">
              <label for="cvc" title="Les 3 derniers chiffres apparaissant sur le panneau signature au verso de votre carte bancaire.">Cryptogramme visuel</label>
              <div id="cvc" class="form-control" style="width: 65px; display: flex; flex-direction: column; justify-content: center;"></div>
            </div>
            <p style="margin-top: 10px; color:red">{{ formCheckout.error }}</p>
            <input :value="checkoutPlan == 'NEWCARD' ? 'Ajouter la carte' : 'Souscrire l\'abonnement'" :disabled="formCheckout.submitDisabled"
                   type="button" class="submit btn btn-success" style="margin-top:15px; width:100%"
                   @click="submitCheckout">
          </form>
          <transition name="fade">
            <div v-if="formCheckout.showSuccess">
              <p style="font-weight: bold;font-size: 32px;margin: 15px 0;">Merci</p>
              <p>Votre compte Premium est maintenant activé.<br>Pensez à compléter vos données de facturation.</p>
              <a :href="`${baseUrl}#company`"><button class="submit btn btn-success" style="margin-top:15px; width:100%">Compléter le compte entreprise</button></a>
            </div>
          </transition>
        </div>
        <div class="py-6 text-center">
          Pas de CB ? <a href="questions-outil-projet-en-ligne?subject=Paiement%20par%20virement" target="_blank">Contactez-nous pour un paiement par virement.</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { printLang } from './lang';
  import apiSrv from './apiSrv';

  export default {
    props: {
      plan: { type: String, required: true }, // BUSINESS, BUSINESS12M, TEAM, TEAM12M, PERSONALLIGHT, NEWCARD
      users: { type: Number, required: true },
      coupon: { type: String, required: true },
    },
    data() {
      return {
        availablePlans: {
          BUSINESS: { name: 'BUSINESS MENSUEL', period: 'mensuel', price: 26.4 },
          BUSINESS12M: { name: 'BUSINESS ANNUEL', period: 'annuel', price: 264 },
          TEAM: { name: 'TEAM MENSUEL', period: 'mensuel', price: 14.4 },
          TEAM12M: { name: 'TEAM ANNUEL', period: 'annuel', price: 144 },
          PERSONALLIGHT: { name: 'PERSONAL LIGHT', period: 'mensuel', price: 8 },
        },
        stripeData: {},
        formCheckout: {
          cardholderName: "",
          submitDisabled: false,
          error: "",
          showSuccess: false,
        },
      };
    },
    computed: {
      checkoutPlan() {
        return this.plan.toUpperCase();
      },
      checkoutPlanName() {
        return (this.availablePlans[this.checkoutPlan] || {}).name || "INVALID";
      },
      checkoutPlanPeriod() {
        return (this.availablePlans[this.checkoutPlan] || {}).period || "";
      },
      checkoutQuantity() {
        if (this.checkoutPlan == 'PERSONALLIGHT') return 1;
        return this.users;
      },
      checkoutPrice() {
        return (this.availablePlans[this.checkoutPlan] || {}).price || 0;
      },
      checkoutCoupon() {
        return ''; // no coupon available at the moment
        // const checkoutCoupon = this.coupon.toUpperCase();
        // return ['BLACKFRIDAY'].includes(checkoutCoupon) && ['TEAM12M', 'BUSINESS12M'].includes(this.checkoutPlan) ? checkoutCoupon : '';
      },
      couponDiscount() {
        return this.checkoutCoupon == 'BLACKFRIDAY' ? 0.2 : 0;
      },
      checkoutTrialEnd() {
        const trialEndDate = new Date(document.querySelector('#myaccount').dataset.today);
        return this.dateFormats(trialEndDate);
      },
      baseUrl() { return printLang('Url'); },
    },
    mounted() {
      this.loadCheckout();
      this.initStripeForm();
    },
    methods: {
      loadCheckout() {
        apiSrv.getApi(`${window.api.buy.url}?plan=${this.checkoutPlan}&quantity=${this.checkoutQuantity}`, () => { // do nothing
        });
      },
      initStripeForm() {
        if (! window.Stripe) {
          setTimeout(this.initStripeForm, 300);
          return;
        }
        this.stripeData.stripe = window.Stripe(window.keys.stripe);
        const elements = this.stripeData.stripe.elements();
        const style = { base: { '::placeholder': { color: '#ccc' } } };
        this.stripeData.number = elements.create('cardNumber', { style });
        this.stripeData.exp = elements.create('cardExpiry', { style });
        this.stripeData.cvc = elements.create('cardCvc', { placeholder: '123', style });
        this.stripeData.number.mount('#number');
        this.stripeData.exp.mount('#exp');
        this.stripeData.cvc.mount('#cvc');
      },
      submitCheckout() {
        if (! window.Stripe) { console.log("Stripe not ready"); return; }
        this.formCheckout.error = "";
        this.formCheckout.submitDisabled = true;

        if (! this.formCheckout.cardholderName) {
          this.formCheckout.error = "Veuillez entrer le nom du titulaire de la carte";
          this.formCheckout.submitDisabled = false;
          return;
        }

        const plan = this.checkoutPlan;
        const quantity = this.checkoutQuantity;
        const coupon = this.checkoutCoupon;
        let apiUrl = `${window.api.buy.url }/plan/${plan}/quantity/${quantity}`;
        if (plan == "NEWCARD") {
          apiUrl = `${window.api.buy.url }/cards`;
        } else if (! quantity || ! this.availablePlans[plan]) {
          this.formCheckout.error = "Erreur: l'offre selectionnée est invalide.";
          return;
        }

        this.stripeData.stripe.createToken(this.stripeData.number, { name: this.formCheckout.cardholderName }).then((response) => {
          if (response.error) {
            this.formCheckout.error = response.error.message;
            this.formCheckout.submitDisabled = false;
          } else {
            const token = response.token.id;
            $.ajax({
              type: 'POST',
              url: apiUrl,
              dataType: "json",
              headers: { 'X-Auth-Token': window.api_token },
              data: { token, coupon },
            }).then((data) => {
              let pendingSetupIntent = data && data.subscription && data.subscription.pending_setup_intent;
              if (pendingSetupIntent && pendingSetupIntent.status === "requires_action") { // 3D secure for a first subscription
                this.stripeData.stripe.handleCardSetup(pendingSetupIntent.client_secret).then((result) => {
                  if (result.error) {
                    this.formCheckout.error = `Error : ${result.error.message}`;
                    this.formCheckout.submitDisabled = false;
                  } else {
                    // success with 3D secure
                    this.formCheckout.showSuccess = true;
                  }
                });
                return;
              }
              if (! pendingSetupIntent) pendingSetupIntent = data && data.subscription && data.subscription.latest_invoice && data.subscription.latest_invoice.payment_intent;
              if (pendingSetupIntent && pendingSetupIntent.status === "requires_action") { // 3D secure for a new subscription
                this.stripeData.stripe.confirmCardPayment(pendingSetupIntent.client_secret).then((result) => {
                  if (result.error) {
                    this.formCheckout.error = `Error : ${result.error.message}`;
                    this.formCheckout.submitDisabled = false;
                  } else {
                    // success with 3D secure
                    this.formCheckout.showSuccess = true;
                  }
                });
                return;
              }
              this.formCheckout.showSuccess = true;
            }).catch((data) => {
              console.log(data);
              let response = {};
              try {
                response = data.responseText ? JSON.parse(data.responseText) : {};
              } catch (e) {
              //
              }
              response.message = window.formatApiAnswer(response.message) || data.statusText;
              this.formCheckout.error = `Error : ${response.message}`;
              this.formCheckout.submitDisabled = false;
            });
          }
        });
      },
      number_format(nbr) {
        let nbrFixed = nbr.toFixed(2);
        if (nbrFixed.endsWith('.00')) nbrFixed = nbrFixed.slice(0, -3);
        const nbrFormated = nbrFixed.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        return nbrFormated.replace('.', ',');
      },
      dateFormats(date) {
        const d = new Date(date);
        let month = `${d.getMonth() + 1}`;
        let day = `${d.getDate()}`;
        const year = d.getFullYear();

        if (month.length < 2) month = `0${month}`;
        if (day.length < 2) day = `0${day}`;

        return {
          fullDate: [day, month, year].join('/'),
          dayAndMonth: [day, month].join('/'),
          day,
        };
      },
    },
  };
</script>
